var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.percent >= 0)?_c('h5',[_vm._v("Sessions "),_c('ProgressBar',{attrs:{"percent":_vm.percent}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }